export const COLORS = {
  primary: '#bcfb9f',
  primaryShadow: '#0FFDFF29',
  secondary: '#AA5389',
  warning: '#EED764',
  error: '#FF4444',
  purple: '#AA5389FF',
  yellow: '#c6d8c5',
  green: '#4BDB78',
  cyan: '#bcfb9f',
  mint: '#bcfb9f',
  cyanShadow: '#00FFFF7A',
  background: '#000000',
  text: '#faf7f2',
  overlay: 'rgba(0, 0, 0, 0.4)',
} as const
